var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetirement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    x: 1,
    y: 1,
    fill: "#b0d3f0",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3b97d3",
    d: "M59 5v4H1V5c0-2.21 1.79-4 4-4h50c2.21 0 4 1.79 4 4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 1,
    fill: "#f0c419"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5,
    r: 1,
    fill: "#e64c3c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5,
    r: 1,
    fill: "#b0d3f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34 6h-8a1 1 0 110-2h8a1 1 0 110 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d55b",
    d: "M53 18.645v1.626c0 .402-.355.728-.794.728H7.793c-.438 0-.793-.326-.793-.728v-1.627c0-.336.251-.629.608-.708l22.021-4.897a1.72 1.72 0 01.742 0l22.021 4.897c.356.079.608.371.608.708z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f29c1f",
    d: "M9 21h6v3a1 1 0 01-1 1h-4a1 1 0 01-1-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d55b",
    d: "M9 51h42a1 1 0 011 1v3H8v-3a1 1 0 011-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f29c1f",
    d: "M8 55h44a1 1 0 011 1v3H7v-3a1 1 0 011-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e57e25",
    d: "M10 25h4v26h-4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f29c1f",
    d: "M45 21h6v3a1 1 0 01-1 1h-4a1 1 0 01-1-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e57e25",
    d: "M46 25h4v26h-4z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 36,
    r: 11,
    fill: "#f0c419"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e57e25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 43c-2.206 0-4-1.794-4-4a1 1 0 112 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4a1 1 0 11-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2c2.206 0 4 1.794 4 4s-1.794 4-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 31a1 1 0 01-1-1v-1a1 1 0 112 0v1a1 1 0 01-1 1zm0 13a1 1 0 01-1-1v-1a1 1 0 112 0v1a1 1 0 01-1 1z"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgRetirement as ReactComponent };